import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material.module';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { TruncatePipe } from '../core/directives/truncate';
import { GoogleSigninButtonModule } from '@abacritt/angularx-social-login';
import { CurrencySymbolPipe } from '../core/services/currency_symbol.service';
import { HighchartsChartModule } from 'highcharts-angular';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { TruncateWithReadMorePipe } from '../core/services/truncate-with-read-more.pipe';
import { NgxEditorModule } from 'ngx-editor';

const Modules = [
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  CommonModule,
  MaterialModule,
  NgxSliderModule,
  GoogleSigninButtonModule,
  HighchartsChartModule,
  InfiniteScrollModule,
  NgxMatSelectSearchModule,
  ShareButtonsModule,
  ShareIconsModule,
  NgxEditorModule
]

const Declarations = [
  TruncatePipe,
  CurrencySymbolPipe,
  TruncateWithReadMorePipe
]

@NgModule({
  declarations: [...Declarations],
  imports: [...Modules],
  exports:[...Modules, ...Declarations]
})
export class AllModule { }
